/*
 * @Author: linguang linguang@nextmar.com
 * @Date: 2025-03-14 19:42:12
 * @LastEditors: linguang linguang@nextmar.com
 * @LastEditTime: 2025-03-19 14:12:40
 * @FilePath: /zeelool-nextjs/src/api/coupon.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { httpRequest } from '@/utils/axios';

export const getCouponsList = () =>
  httpRequest('GET:/api/customer/coupon_type_list', {
    params: {
      'filter[show_view]': 1,
    },
  });

export const getCoupon = (couponId: number) =>
  httpRequest('POST:/api/customer/get_coupon', {
    data: {
      coupon_id: couponId.toString(),
    },
  });
